/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkAddReferenceableSyncEntity} from '../api'

export const useMutationBulkAddReferenceableSyncEntity = createReactQueryMutationHook('bulkAddReferenceableSyncEntity', bulkAddReferenceableSyncEntity)
